import { getHSDocumentsCommit, getHSDocumentsFailed, updateDocReadAtCommit, updateDocReadAtFailed } from '../slices/hsDocumentsSlice';
import { OfflineAction } from './types';

export const getHSDocuments = (): OfflineAction => ({
  type: "hsDocuments/getHSDocuments",
  meta: {
    offline: {
      effect: {
        url: `/hs_documents`,
        method: 'GET'
      },
      commit: { type: getHSDocumentsCommit.type },
      rollback: { type: getHSDocumentsFailed.type },
    }
  }
});

export const updateDocReadAt = (data: any): OfflineAction => ({
  type: "hsDocuments/updateDocReadAt",
  payload: data,
  meta: {
    offline: {
      effect: {
        url: `/hs_documents/read_at`,
        method: 'POST',
        body: data
      },
      commit: { type: updateDocReadAtCommit.type },
      rollback: { type: updateDocReadAtFailed.type },
    }
  }
});